import { Component, Input } from "@angular/core";
import { Dialog } from "@angular/cdk/dialog";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { InfoModalComponent } from "./info-modal.component";
import { InfoModalData } from "./info-modal.model";

@Component({
  selector: "app-info-modal-button",
  standalone: true,
  imports: [FaIconComponent],
  host: { class: "inline-flex items-center" },
  template: `
    <button
      type="button"
      class="inline-flex items-center text-momentum-deep_purple hover:text-momentum-royal_purple transition-colors"
      [attr.aria-label]="'Learn more about ' + data.title"
      (click)="open()"
    >
      <fa-icon [icon]="faCircleInfo" size="lg"></fa-icon>
    </button>
  `
})
export class InfoModalButtonComponent {
  @Input() data!: InfoModalData;

  protected readonly faCircleInfo: IconDefinition = faCircleInfo;

  constructor(private readonly dialog: Dialog) {}

  protected open(): void {
    this.dialog.open<void, InfoModalData>(InfoModalComponent, {
      data: this.data,
      panelClass: ["flex", "items-center", "justify-center"]
    });
  }
}
